module.exports = __webpack_public_path__ + "static/img/keep_member_bg.cdec2f62.png";